<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="toPage('/')">
        <div class="company-name">佛山市纳木措国际货运代理有限公司</div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="
            item.type !== 'btn'
              ? item.routerName == $route.name ||
                (item.routerName === 'home' && $route.name === 'product_intro')
                ? 'active'
                : ''
              : 'header-btn'
          "
          @click="navClick(item.routerName, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline" v-if="item.type !== 'btn'"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          class="center-block"
          src="@/assets/img/header/pic_blacklogo.png"
          alt="logo"
        />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ $route.meta.routerName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="
              item.routerName == $route.name ||
              (item.routerName === 'home' && $route.name === 'product_intro')
                ? 'active'
                : ''
            "
            @click="navClick(item.routerName, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          routerName: "home",
          path: "/",
          children: []
        },
        {
          name: "国际物流",
          path: "/product",
          routerName: "product",
          children: []
        },
        {
          name: "物流查询",
          path: "/search",
          routerName: "search",
          children: []
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          routerName: "about_us",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(routerName, name) {
      this.$store.dispatch("SetRouter", routerName);
      this.$store.dispatch("SetMenuName", name);
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    toPage(link) {
      if (this.$route.name !== "home") {
        this.$router.push(link);
      }
    }
  }
};
</script>
<style scoped>
.company-name {
  font-size: 20px;
}
/* 顶部 */
#header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  background: #ffffff;
  transition: all ease 0.6s;
  box-shadow: 0px 4px 18px 0px rgba(86, 111, 109, 0.08);
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  padding: 0 110px;
  height: 64px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  cursor: pointer;
  /* width: 164px; */
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 158px;
  height: 32px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 64px;
  float: right;
  margin: 0;
  /* max-width: 800px; */
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #262626;
  font-size: 14px;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #408cd5;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #408cd5;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #408cd5;
  text-decoration: none;
  border-bottom: 2px solid #408cd5;
}
/* 导航栏 按钮 */
#header .header-nav .header-nav-wrapper > li.header-btn {
  margin: 0 0 0 20px;
}
#header .header-nav .header-nav-wrapper > li.header-btn > a {
  padding: 6.5px 16px;
  background: #408cd5;
  font-size: 14px;
  color: #ffffff;
  border-radius: 4px;
  text-decoration: none;
}
#header .header-nav .header-nav-wrapper > li.btn-active > a,
#header .header-nav .header-nav-wrapper > li.header-btn > a:hover {
  padding: 6.5px 16px;
  background: #2fd5c1;
  font-size: 14px;
  color: #ffffff;
  border-radius: 4px;
  text-decoration: none;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (min-width: 810px) and (max-width: 1025px) {
  #header .header-nav {
    padding: 0 55px;
  }
}
@media screen and (max-width: 997px) {
  #header .header-nav .header-nav-wrapper > li {
    margin: 0 15px;
  }
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 164px;
    height: 32px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 14px;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}

@media screen and (max-width: 810px) {
  #header .header-nav {
    padding: 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue